import { render, staticRenderFns } from "./shenpi.vue?vue&type=template&id=d0428566&scoped=true"
import script from "./shenpi.vue?vue&type=script&lang=js"
export * from "./shenpi.vue?vue&type=script&lang=js"
import style0 from "./shenpi.vue?vue&type=style&index=0&id=d0428566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0428566",
  null
  
)

export default component.exports